import { BATCH_MODE, BATCH_PHASE } from './activityBatchConversion.constants';

// Un lote sin `mode` (listados anteriores a la conversión) es de generación: es el único modo que
// existía, no un dato inventado.
export function getBatchMode(batch) {
  const mode = String(batch?.mode ?? '').toLowerCase();

  return mode === BATCH_MODE.CONVERT ? BATCH_MODE.CONVERT : BATCH_MODE.GENERATE;
}

export function isConvertBatch(batch) {
  return getBatchMode(batch) === BATCH_MODE.CONVERT;
}

// Fase del progreso mientras un lote convert está en marcha; null fuera de las dos fases conocidas
// (en generación siempre es null).
export function getBatchPhase(progress) {
  const phase = String(progress?.phase ?? '').toLowerCase();

  return Object.values(BATCH_PHASE).includes(phase) ? phase : null;
}

export function getBatchModeLabelKey(batch) {
  return `activityBatches:mode_${getBatchMode(batch)}`;
}
